import { Colors } from "src/styles/DesignSystem";
import styled from "styled-components";

export const CtaWrapper = styled.button`
    padding: .75rem 1.2rem;
    border-radius: 25px;
    background: ${Colors.gradient};

    display: flex;
    align-items: center;

    font: 1rem/1 'Varela Round',arial,sans-serif;
    color: ${Colors.white};
    transition: all ease-in .25s;
    cursor: pointer;

    svg{
        margin-left: 10px;
        width: 20px;
        height: 20px;
        padding: .25rem;
        background-color: ${Colors.brown};
        border-radius: 50%;
        fill: ${Colors.white};
        transition: all ease-in .25s;
    }

    &:hover{
        padding-right: 1.75rem;

        svg{
            transform: translateX(5px);
        }
    }
`;